// app/javascript/controllers/kanban_controller.js
import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      group: 'programs', // Allows dragging cards between columns
      animation: 150,
      ghostClass: 'sortable-ghost', // CSS class for the placeholder while dragging
      dragClass: 'sortable-drag',   // CSS class for the item being dragged
      onEnd: this.end.bind(this)
    })
  }

  // This method runs when a drag operation finishes (a card is dropped)
  async end(event) {
    // Save the original position of the card in case we need to revert
    const item = event.item;
    const fromList = event.from;
    const oldIndex = event.oldIndex;

    const columnId = this.element.id; // e.g., 'in-progress-programs'
    const status = columnId.split('-')[0]; // Extracts 'untouched', 'in', or 'ready'

    // Get the ID of the program card that was dragged
    const programId = event.item.dataset.programId;

    // Build the data payload
    const data = new FormData();
    data.append('program[status]', status);

    try {
      // Use Turbo/Fetch to send the update to the Rails controller
      const response = await fetch(this.urlValue.replace(':id', programId), {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
          'Accept': 'application/json'
        },
        body: data
      });

      // Handle the validation/redirect failure (422)
      if (response.status === 422) {
        const responseData = await response.json();

        if (responseData.redirect_to) {
          // Revert the card and redirect
          Sortable.get(fromList)._onDrop({
            item: item,
            to: fromList,
            from: item.parentElement,
            oldIndex: oldIndex,
            newIndex: oldIndex
          });
          window.location.href = responseData.redirect_to;
        } else {
          // Handle other standard validation errors
          console.error("Validation Error:", responseData);
          throw new Error('Update failed due to validation errors.');
        }
        return; // Exit the function after handling 422
      } else if (response.status === 403) {
        // Handle authorization failure (403 Forbidden)
        const responseData = await response.json();

        console.error("Authorization Error:", responseData);
        this.revertDrag(item, fromList, oldIndex);
        return; // Exit after handling 403

      }

      // Handle network errors (status 400s or 500s that aren't 422)
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      };

    } catch(error) {
      console.error("Error updating program status:", error);
      // Revert the drag on failure
      Sortable.get(fromList)._onDrop({
        item: item,
        to: fromList,
        from: item.parentElement,
        oldIndex: oldIndex,
        newIndex: oldIndex
      });
      alert("An unexpected error occurred. Please try again.");
    };
  }
}
